import React from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from 'antd';
import moment from 'moment';

const { RangePicker } = DatePicker;

export default function DateRangeFilter({ onChange, value, earliestSelectableDate, style }) {
  const disabledDateCheck = (date) => new Date(date) < new Date(earliestSelectableDate);

  return (
    <div className={`filter-container ${value ? 'active' : ''}`} style={style}>
      <img src="/assets/icons/filters/calendar.svg" alt="Date Range filter" />
      <RangePicker
        value={value}
        style={{ width: '90%' }}
        format="DD MMM YY"
        onChange={onChange}
        disabledDate={disabledDateCheck}
      />
    </div>
  );
}

DateRangeFilter.propTypes = {
  onChange: PropTypes.any.isRequired,
};

export const applyDateRangeFilter = (booking, dateRange) => {
  if (!dateRange || !dateRange.length) return true;

  const filterStartDate = moment(dateRange[0]);
  const filterEndDate = moment(dateRange[1]);
  const collectionDate = moment(booking.collectionDateTimeLocal);
  const collectionDateInRange = moment(collectionDate).isBetween(filterStartDate, filterEndDate, 'day', '[]');

  return collectionDateInRange;
};
